import React, { useEffect } from "react";
import Header from "../component/Header";
import SubBanner from "../component/SubBanner";
import HomeBlog from "../component/HomeBlog";
import Footer from "../component/Footer";
import BlogContent from "../component/BlogContent";
import "../scss/blog.scss";

import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchBlogDetails,
  fetchBlogCategory,
} from "../features/blog/blogActions";
import {
  fetchServices
} from "../features/service/serviceActions";

import { Helmet } from "react-helmet-async";

function BlogDetails() {
  // Get the slug from the URL
  const { slug } = useParams();

  const dispatch = useDispatch();
  const { blogDetails, blogCategories } = useSelector((state) => state.blog);
  const { services } = useSelector((state) => state.service);

  useEffect(() => {
    dispatch(fetchBlogDetails(slug));
    dispatch(fetchBlogCategory({page:1, limit: 25}));
    dispatch(fetchServices({page:1, limit: 25}))
  }, [dispatch, slug]);

  return (
    <>
      <Helmet>
        <title>{blogDetails?.meta_title}</title>
        <meta name="description" content={blogDetails?.meta_description} />
        <meta name="keywords" content={blogDetails?.meta_keywords} />
      </Helmet>

      <main className="blog-page">
        <Header />
        <SubBanner HeaderTitle="Our Blogs" />

        {blogDetails !== null && (
          <>
            <BlogContent blogDetails={blogDetails} blogCategories={blogCategories?.data?? []} services={services?.data??[]} />
            <HomeBlog blogCategoryId={blogDetails?.blog_category_id} />
          </>
        )}
      </main>
      <Footer />
    </>
  );
}
export default BlogDetails;
